import { useWidgetContext } from '../../../../../Widget'
import { ApplicantIdentityWidgetForm } from '../ApplicantIdentityWidgetForm'
import { ApplicantIdentityWidgetReadView } from '../ApplicantIdentityWidgetReadView'

function ApplicantIdentityWidgetContent() {
  const { handleDisableEditMode, isEditMode } = useWidgetContext()

  return isEditMode ? (
    <ApplicantIdentityWidgetForm
      onClose={handleDisableEditMode}
      onSuccess={handleDisableEditMode}
    />
  ) : (
    <ApplicantIdentityWidgetReadView />
  )
}

export default ApplicantIdentityWidgetContent
